export type UnitSelection = 'floor' | 'beacon' | 'user' | 'card'

export const UnitStoreAction = {
    floor: {
        hasRef: true,
        type: 'floor',
    },
    beacon: {
        hasRef: false,
        type: 'beacon',
    },
    user: {
        hasRef: true,
        type: 'user',
    },
    card: {
        hasRef: false,
        type: 'card',
    }
}